import { Input } from "@arcadeai/design-system/components/ui/atoms/input";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import type { Control } from "react-hook-form";
import type { UserSourceCreateRequest } from "../../types";

type ClientIdFormFieldProps = {
  control: Control<UserSourceCreateRequest>;
};

export function ClientIdFormField({ control }: ClientIdFormFieldProps) {
  return (
    <FormField
      control={control}
      name="client_id"
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            Client ID
            <span className="text-destructive"> *</span>
          </FormLabel>
          <FormControl>
            <Input {...field} autoComplete="off" />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
